<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="w-100 d-flex flex-row justify-content-between">
          <div>لیست پیام های ارسالی به ادمین</div>
          <v-btn
            class="float-left"
            color="primary"
            @click="returnToTradeRequestList()"
            >بازگشت به لیست درخواست ها</v-btn
          >
        </div>
      </v-card-title>
      <v-divider> </v-divider>
      <v-card-text>
        <BusinessInformationConversationList
          :businessInformationConversationList="
            businessInformationConversationList
          "
          @getBusinessInformationConversaion="getBusinessInformationConversaion"
        >
        </BusinessInformationConversationList>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BusinessInformationConversationList from '../components/BusinessInformationConversationList.vue';
import Helper from '@/core/helpers';
const businessInformationConversationRepository = () =>
  RepoFactory.get('businessInformationConversation');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  components: {
    BusinessInformationConversationList,
  },
  data() {
    return {
      businessInformationConversationList: null,
    };
  },
  watch: {
    merchantId() {
      if (this.merchantId) {
        this.getBusinessInformationConversaion();
      }
    },
  },
  computed: {
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    if (this.merchantId) {
      console.log(this.merchantId);
      this.getBusinessInformationConversaion();
    }
  },
  methods: {
    returnToTradeRequestList() {
      this.clearStore();
      this.$router.push({ path: `/trade-request` });
    },
    clearStore() {
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestCategoryType', null);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestResponsesPerItem', null);
      this.$store.commit('setTradeRequestNumber', null);
      this.$store.commit('setTradeRequestDate', null);
      this.$store.commit('setTradeRequestResponsesHeader', null);
      this.$store.commit('setTradeRequestSelectedForResponse', null);
    },
    getBusinessInformationConversaion() {
      const loader = this.$loading.show();
      let param = {
        objectId: this.merchantId,
        type: 'AdminMerchant',
        topic: 'Merchant',
      };
      businessInformationConversationRepository()
        .getConversation(this.contentBaseUrl, {}, param)
        .then((res) => {
          this.businessInformationConversationList = res.data;
        })
        .catch((err) => {
          loader.hide();
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style lang="scss" scoped></style>
